var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isLoaded
        ? _c("form-wrap", {
            scopedSlots: _vm._u(
              [
                _vm._l(_vm.$scopedSlots, function(slotContent, slotName) {
                  return {
                    key: slotName,
                    fn: function() {
                      return [_vm._t(slotName)]
                    },
                    proxy: true
                  }
                })
              ],
              null,
              true
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }